export default __webpack_public_path__ + "static/media/bankCard.cb195adb.svg";